"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var TouchScreen_exports = {};
__export(TouchScreen_exports, {
  default: () => TouchScreen_default
});
module.exports = __toCommonJS(TouchScreen_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M8.50781 13.5703V5.69922C8.50781 5.41276 8.60547 5.16536 8.80078 4.95703C9.00911 4.7487 9.25651 4.64453 9.54297 4.64453C9.82943 4.64453 10.0703 4.7487 10.2656 4.95703C10.474 5.16536 10.5781 5.41276 10.5781 5.69922V10.25H12.0039C12.069 10.25 12.1341 10.2565 12.1992 10.2695C12.2643 10.2826 12.3294 10.3021 12.3945 10.3281L15.6758 11.9492C15.8711 12.0273 16.0273 12.1576 16.1445 12.3398C16.2747 12.5091 16.3398 12.7044 16.3398 12.9258C16.3398 12.9518 16.3333 12.9779 16.3203 13.0039C16.3203 13.0299 16.3203 13.0495 16.3203 13.0625L15.7734 16.832C15.7344 17.0924 15.6172 17.3138 15.4219 17.4961C15.2396 17.6654 15.0117 17.75 14.7383 17.75H8.99609C8.85286 17.75 8.70964 17.724 8.56641 17.6719C8.4362 17.6068 8.32552 17.5286 8.23438 17.4375L4.66016 13.9023L5.24609 13.3359C5.3112 13.2708 5.38932 13.2188 5.48047 13.1797C5.58464 13.1276 5.69531 13.1016 5.8125 13.1016C5.83854 13.1016 5.86458 13.1081 5.89062 13.1211C5.91667 13.1211 5.94922 13.1211 5.98828 13.1211L8.50781 13.5703ZM7.72656 8.62891C7.29688 8.34245 6.95182 7.96484 6.69141 7.49609C6.43099 7.02734 6.30078 6.51953 6.30078 5.97266C6.30078 5.07422 6.61328 4.3125 7.23828 3.6875C7.8763 3.0625 8.64453 2.75 9.54297 2.75C10.4414 2.75 11.2031 3.0625 11.8281 3.6875C12.4661 4.3125 12.7852 5.07422 12.7852 5.97266C12.7852 6.51953 12.6549 7.02734 12.3945 7.49609C12.1341 7.96484 11.7826 8.34245 11.3398 8.62891V5.71875C11.3398 5.22396 11.1641 4.80078 10.8125 4.44922C10.4609 4.09766 10.0378 3.92188 9.54297 3.92188C9.04818 3.92188 8.61849 4.09766 8.25391 4.44922C7.90234 4.80078 7.72656 5.22396 7.72656 5.71875V8.62891Z",
      fill: "currentColor"
    }
  )
);
const SvgTouchScreen = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var TouchScreen_default = SvgTouchScreen;
